import {
  LearningOutcomeItem,
  LearningOutcomesStatusEnum,
  QueryParams,
} from './types';
import { _util } from '@/tools/declare/global/$util';
import { _axiosInstance } from '@/tools/declare/global/$axiosInstance';

const learningOutcomesService = {
  getLearningOutcomes: async (
    params: QueryParams = {}
  ): Promise<Array<LearningOutcomeItem>> => {
    const {
      data: { data },
    } = await _util.errorAxiosHandler(async () => {
      return await _axiosInstance.get(
        LearningOutcomesStatusEnum.GET_LEARNING_OUTCOMES,
        {
          params: {
            limit: 100,
            ...params,
          },
        }
      );
    });
    return data;
  },
};

// TODO: декомпозировать, написать yml, доку, закинуть в Readme.md
export { learningOutcomesService };



// WEBPACK FOOTER //
// ./src/pages/profile/views/resultCourses/service.ts